import React, { useEffect, useState } from 'react';
import HeaderEntreprise from '../../header/headerEntreprise';
import Footer from '../../commun/Footer';
import FactureList from '../../commun/FactureList';
import HeaderRec from '../../header/headerRec';
import Chatbox from '../../commun/ChatBox';

const FacturesRecruteur = () => {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const userId = localStorage.getItem("userId");
  const recruteurName = localStorage.getItem("recruteurName");
  const authToken = localStorage.getItem('authToken');

  const columns = [
    { key: 'numeroFacture', label: 'Facture #' },
    { key: 'mission', label: 'Mission' },
    { key: 'recruteur', label: 'Recruteur' },
    { key: 'montant', label: 'Montant' },
    { key: 'statut', label: 'Statut' },
    { key: 'dateCreation', label: 'Date de création' },
  ];

  return (
    <>
       <HeaderRec recruteurName={recruteurName} authToken={authToken}  userId={userId} />
       <FactureList
          fetchUrl={`${API_BASE}/api/Recruteur/facture/${userId}`} 
          headerComponent={HeaderRec}
          footerComponent={Footer}
          columns={columns}
          userType="recruteur"
        />
    </>
  );
};

export default FacturesRecruteur;
